/* ECLISS — core theme script (no dependencies) */
(() => {
  const EC = (window.EC = window.EC || {});
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  EC.$ = $; EC.$$ = $$;
  const R = () => EC.routes || {};

  /* ---------- Money ---------- */
  const fmtNum = (n, dec, ts, ds) => {
    const s = n.toFixed(dec).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    return s[1] ? s[0] + ds + s[1] : s[0];
  };
  EC.money = (cents) => {
    const v = (Number(cents) || 0) / 100;
    const fmt = EC.moneyFormat || '{{amount_with_comma_separator}} €';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(v, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(v, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(v, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(v, 2, "'", '.');
        default: return fmtNum(v, 2, ',', '.');
      }
    });
  };

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock');
    setTimeout(() => { const f = d.querySelector('[data-autofocus]') || d.querySelector('.drawer__head button'); f && f.focus({ preventScroll: true }); }, 80);
  };
  const closeDrawer = (d) => {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  EC.openDrawer = openDrawer; EC.closeDrawer = closeDrawer;
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) {
      if (o.dataset.open === 'cart-drawer' && EC.cartType !== 'drawer') return;
      e.preventDefault(); openDrawer(o.dataset.open); return;
    }
    const c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer($('.drawer.is-open')); });

  /* ---------- Cart ---------- */
  const fetchJSON = (url, opts = {}) => fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts))
    .then((r) => r.json().then((j) => { if (!r.ok) throw j; return j; }));
  const isCartPage = () => document.body.classList.contains('t-cart');

  const syncBundle = async (cart) => {
    const B = EC.bundle;
    if (!B || !B.enabled) return cart;
    const qty = cart.items.reduce((n, i) => n + (B.pids.indexOf(i.product_id) > -1 ? i.quantity : 0), 0);
    const want = qty >= 3 && B.c3 ? B.c3 : qty >= 2 && B.c2 ? B.c2 : '';
    const ours = [B.c2, B.c3].filter(Boolean).map((c) => c.toUpperCase());
    const codes = (cart.discount_codes || []).map((d) => (d.code || '').toUpperCase());
    const others = codes.filter((c) => ours.indexOf(c) < 0);
    const current = codes.find((c) => ours.indexOf(c) > -1) || '';
    if (current === want.toUpperCase()) return cart;
    const list = others.concat(want ? [want] : []).join(',');
    try { return await fetchJSON(R().cart_update + '.js', { method: 'POST', body: JSON.stringify({ discount: list }) }); }
    catch (err) { return cart; }
  };

  const renderCart = async (cart) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count; el.dataset.count = cart.item_count;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
    if (isCartPage()) { window.location.reload(); return; }
    try {
      const res = await fetch(R().root + '?sections=ec-cart-drawer').then((r) => r.json());
      const tmp = document.createElement('div');
      tmp.innerHTML = res['ec-cart-drawer'];
      const fresh = tmp.querySelector('[data-cart-inner]');
      const cur = $('[data-cart-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
    } catch (err) { /* noop */ }
  };

  EC.cart = {
    get: () => fetchJSON(R().cart + '.js'),
    async refresh() {
      let cart = await this.get();
      cart = await syncBundle(cart);
      await renderCart(cart);
      document.dispatchEvent(new CustomEvent('ec:cart', { detail: cart }));
      return cart;
    },
    async add(items) {
      const res = await fetchJSON(R().cart_add + '.js', { method: 'POST', body: JSON.stringify({ items }) });
      await this.refresh();
      return res;
    },
    async change(line, quantity) {
      await fetchJSON(R().cart_change + '.js', { method: 'POST', body: JSON.stringify({ line, quantity }) });
      return this.refresh();
    }
  };

  // Product forms (AJAX when drawer cart)
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-ec-form]');
    if (!f || EC.cartType !== 'drawer') return;
    e.preventDefault();
    const btn = f.querySelector('[type="submit"]');
    const err = f.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    btn && btn.classList.add('is-loading');
    const fd = new FormData(f);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    try {
      await EC.cart.add([item]);
      openDrawer('cart-drawer');
    } catch (x) {
      if (err) { err.textContent = x.description || x.message || 'Impossible d’ajouter ce produit pour le moment.'; err.hidden = false; }
    } finally { btn && btn.classList.remove('is-loading'); }
  });

  // Cart drawer interactions
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty-btn]');
    if (q) {
      e.preventDefault();
      const inner = q.closest('[data-cart-inner]'); inner && (inner.style.opacity = '.55');
      await EC.cart.change(Number(q.dataset.line), Math.max(0, Number(q.dataset.qty)));
      return;
    }
    const a = e.target.closest('[data-add-variant]');
    if (a) {
      e.preventDefault();
      a.classList.add('is-loading');
      try { await EC.cart.add([{ id: Number(a.dataset.addVariant), quantity: Number(a.dataset.qty || 1) }]); openDrawer('cart-drawer'); }
      catch (x) { /* noop */ }
      a.classList.remove('is-loading');
    }
  });
  document.addEventListener('change', async (e) => {
    const i = e.target.closest('[data-qty-input]');
    if (!i) return;
    await EC.cart.change(Number(i.dataset.line), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Header / announcement ---------- */
  const initHeader = () => {
    const h = $('.hdr');
    if (h && !h.dataset.init) {
      h.dataset.init = 1;
      const on = () => h.classList.toggle('is-scrolled', window.scrollY > 8);
      on(); window.addEventListener('scroll', on, { passive: true });
    }
    $$('[data-ann]').forEach((a) => {
      if (a.dataset.init) return; a.dataset.init = 1;
      const msgs = $$('.ann__msg', a);
      if (msgs.length < 2) return;
      let i = 0;
      setInterval(() => {
        if (a.classList.contains('ann--spread') && window.matchMedia('(min-width:1100px)').matches) return;
        msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
      }, Number(a.dataset.speed || 4500));
    });
  };

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' })
    : null;
  const initReveal = (root = document) => $$('.rv:not(.in)', root).forEach((el) => (io ? io.observe(el) : el.classList.add('in')));

  /* ---------- Rails ---------- */
  const initRails = (root = document) => {
    $$('[data-rail-wrap]', root).forEach((w) => {
      if (w.dataset.init) return; w.dataset.init = 1;
      const r = $('.rail', w), p = $('[data-rail-prev]', w), n = $('[data-rail-next]', w);
      if (!r) return;
      const step = () => (r.firstElementChild ? r.firstElementChild.getBoundingClientRect().width + 14 : r.clientWidth * 0.8);
      p && p.addEventListener('click', () => r.scrollBy({ left: -step(), behavior: 'smooth' }));
      n && n.addEventListener('click', () => r.scrollBy({ left: step(), behavior: 'smooth' }));
      const upd = () => { if (p) p.disabled = r.scrollLeft < 4; if (n) n.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4; };
      r.addEventListener('scroll', upd, { passive: true }); upd();
    });
  };

  /* ---------- Tabs ---------- */
  const initTabs = (root = document) => {
    $$('[data-tabs]', root).forEach((t) => {
      if (t.dataset.init) return; t.dataset.init = 1;
      t.addEventListener('click', (e) => {
        const b = e.target.closest('[data-tab]');
        if (!b) return;
        $$('[data-tab]', t).forEach((x) => x.setAttribute('aria-selected', x === b ? 'true' : 'false'));
        $$('[data-panel]', t).forEach((p) => { p.hidden = p.dataset.panel !== b.dataset.tab; });
      });
    });
  };

  EC.init = (root = document) => { initHeader(); initReveal(root); initRails(root); initTabs(root); document.dispatchEvent(new CustomEvent('ec:init', { detail: root })); };
  const boot = () => EC.init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => EC.init(e.target));
})();